import { Brand } from 'constants/brand';

export const SVG_MASK_TYPES = {
  [Brand.GP]: 'multiCircles',
  [Brand.FM]: 'rect',
};
